import React, { useEffect, useRef } from 'react';
import { useNotification } from './NotificationProvider';
import NotificationCard from './NotificationCard';
import { onNotificationClick } from '../../directUser/utils';

const NotificationList = () => {
  const {
    threadData = [],
    loadMoreLoading,
    markAllAsRead,
    loadMore,
    selfName,
    isClient,
    isReadCollapsed,
    setIsReadCollapsed,
  } = useNotification();
  const scrollListRef = useRef();

  const markAllNotificationAsRead = () => {
    markAllAsRead();
  };

  const handleListScroll = (event) => {
    if (
      !loadMoreLoading &&
      event.target.scrollHeight ===
        event.target.scrollTop + event.target.clientHeight
    ) {
      loadMore();
    }
  };

  useEffect(() => {
    scrollListRef.current &&
      scrollListRef.current.addEventListener('scroll', handleListScroll);
    return () => {
      scrollListRef.current &&
        scrollListRef.current.removeEventListener('scroll', handleListScroll);
    };
  }, [loadMoreLoading]);

  if (!threadData || !threadData.length) {
    return (
      <div className="notification-list-wrapper">
        <div className="no-notification-placeholder">No Notification</div>
      </div>
    );
  }

  const readedList = (threadData || []).filter(
    (v) => v.readStatus && !v.markAllStage,
  );
  const unreadList = (threadData || []).filter(
    (v) => !v.readStatus || v.markAllStage,
  );
  const disabledMarkAll = !(threadData || []).filter((v) => !v.readStatus)
    .length;

  return (
    <div ref={scrollListRef} className="notification-list-wrapper">
      {/* Unread */}
      {unreadList && unreadList.length ? (
        <>
          <div className="list-section-title">
            <span>Unread</span>
            <span
              className={`mark-all-button ${
                disabledMarkAll ? 'disabled-mark-all-button' : ''
              }`}
              onClick={() => !disabledMarkAll && markAllNotificationAsRead()}
            >
              <span className="appkiticon icon-check-mark-fill" />
              Mark all as read
            </span>
          </div>
          <NotificationCard
            listData={unreadList}
            selfName={selfName}
            isClient={isClient}
            onNotificationClick={onNotificationClick}
          />
        </>
      ) : null}

      {/* Read */}
      {readedList && readedList.length ? (
        <div style={{ display: isReadCollapsed ? 'none' : 'block' }}>
          <div className="list-section-title">
            <span>Read</span>
            <span
              className="mark-all-button"
              onClick={() => setIsReadCollapsed(!isReadCollapsed)}
            >
              Collapse
            </span>
          </div>
          <NotificationCard
            listData={readedList}
            isReaded={true}
            selfName={selfName}
            isClient={isClient}
            onNotificationClick={onNotificationClick}
          />
        </div>
      ) : null}
    </div>
  );
};

export default NotificationList;
